
import store from '@/store'

export function getToken() {
  return sessionStorage.getItem('token')
}

export function setToken(token) {
  return new Promise(resolve => {
    sessionStorage.setItem('token', token)
    store.dispatch('setToken', token).then(() => {
      resolve()
    })
  })
}

export function resetToken() {
  sessionStorage.clear()
  store.dispatch('resetToken')
}
